import { UpdateCertificateOfCoursesRequest } from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryCertificateOfCoursesService = {
  async get(collaboratorId: number, courseId: number): Promise<ArrayBuffer> {
    const response = await httpClient.get<ArrayBuffer>(
      `v1/collaborators/${collaboratorId}/history/courses/${courseId}/certificate`,
      { responseType: "arraybuffer" },
    );

    return response;
  },
  async update(
    collaboratorId: number,
    courseId: number,
    body: UpdateCertificateOfCoursesRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/courses/${courseId}/certificate`,
      body,
      { contentType: "multipart/form-data" },
    );
  },
  async delete(collaboratorId: number, courseId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/courses/${courseId}/certificate`,
    );
  },
};

export default CollaboratorsHistoryCertificateOfCoursesService;
